import { render, staticRenderFns } from "./TenantModal.vue?vue&type=template&id=4ce51315&"
import script from "./TenantModal.vue?vue&type=script&lang=js&"
export * from "./TenantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce51315')) {
      api.createRecord('4ce51315', component.options)
    } else {
      api.reload('4ce51315', component.options)
    }
    module.hot.accept("./TenantModal.vue?vue&type=template&id=4ce51315&", function () {
      api.rerender('4ce51315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/TenantModal.vue"
export default component.exports